import { TrackerIntegrationOptionData } from "../../types/trackerIntegrationOption.type";

export class TrackerIntegrationOptionsTransformer {
  static optionsTransformer() {
    return (trackerIntegrationOptions: TrackerIntegrationOptionData[]) => {
      return trackerIntegrationOptions.map((option) => {
        return {
          value: option.id,
          label: option?.provider_klass || '',
          parameters: option.required_parameters
        };
      });
    };
  }
}
